export default class KeystrokeJsonDetector {
    constructor(onJsonDetected) {
        if (typeof onJsonDetected !== "function") {
            throw new Error(
                "KeystrokeJsonDetector requires a callback function"
            );
        }

        this.buffer = "";
        this.onJsonDetected = onJsonDetected;
        this.listener = this.handleKeyDown.bind(this);

        document.addEventListener("keydown", this.listener);
    }

    /**
     * @private
     */
    handleKeyDown(event) {
        const { key } = event;

        if (key.length === 1) {
            this.buffer += key;
        } else if (key === "Backspace") {
            this.buffer = this.buffer.slice(0, -1);
        }

        this.attemptParseJson();
    }

    /**
     * @private
     */
    attemptParseJson() {
        if (!this.hasBalancedBrackets(this.buffer)) {
            // We either have no brackets or they aren't balanced, which indicates no JSON or partial JSON
            return;
        }

        const explodedBuffer = this.buffer.split("");
        let cleanJsonBuffer = "";

        explodedBuffer.reverse();

        // Add each character in reverse until the brackets are balanced, as then it's _probably_ valid JSON
        for (const char of explodedBuffer) {
            cleanJsonBuffer = char.concat(cleanJsonBuffer);

            if (this.hasBalancedBrackets(cleanJsonBuffer)) {
                break;
            }
        }

        try {
            const parsed = JSON.parse(cleanJsonBuffer);

            this.onJsonDetected(parsed);
            this.buffer = "";
        } catch {
            // Not valid JSON yet — skip
        }
    }

    /**
     * @private
     */
    hasBalancedBrackets(str) {
        const bracketPairs = {
            "{": "}",
            "[": "]",
        };
        const startingBracketCounter = {
            "{": 0,
            "[": 0,
        };
        const finishingBracketCounter = {
            "}": 0,
            "]": 0,
        };

        let hasAtLeastOneStartingBracket = false;
        str.split("").forEach((char) => {
            if (char in startingBracketCounter) {
                startingBracketCounter[char] += 1;
                hasAtLeastOneStartingBracket = true;
            }

            if (char in finishingBracketCounter) {
                finishingBracketCounter[char] += 1;
            }
        });

        let isBalanced = true;
        Object.keys(bracketPairs).forEach((startingBracket) => {
            const endingBracket = bracketPairs[startingBracket];

            if (
                startingBracketCounter[startingBracket] !==
                finishingBracketCounter[endingBracket]
            ) {
                isBalanced = false;
            }
        });

        return hasAtLeastOneStartingBracket && isBalanced;
    }

    stop() {
        document.removeEventListener("keydown", this.listener);
    }
}
